/**
 * Map variety (D132): what a map looks like (biome), when it is played
 * (light), and how it is laid out (shape). Biome and light are visual only;
 * shape changes the terrain the simulation sees, deterministically from the
 * map config (so every client builds the same map).
 */
export type BiomeId = 'valley' | 'prairie' | 'desert' | 'swamp' | 'tundra' | 'autumn' | 'canyon' | 'deadwood';
export type LightId = 'day' | 'dusk' | 'night';
export type MapShape = 'standard' | 'river' | 'canyon' | 'lakes' | 'coast' | 'dunes' | 'forest' | 'city';

export const BIOMES: readonly BiomeId[] = ['valley', 'prairie', 'desert', 'swamp', 'tundra', 'autumn', 'canyon', 'deadwood'];
export const LIGHTS: readonly LightId[] = ['day', 'dusk', 'night'];
export const SHAPES: readonly MapShape[] = ['standard', 'river', 'canyon', 'lakes', 'coast', 'dunes', 'forest', 'city'];

export const isBiome = (v: unknown): v is BiomeId => typeof v === 'string' && (BIOMES as readonly string[]).includes(v);
export const isLight = (v: unknown): v is LightId => typeof v === 'string' && (LIGHTS as readonly string[]).includes(v);
export const isShape = (v: unknown): v is MapShape => typeof v === 'string' && (SHAPES as readonly string[]).includes(v);

export const BIOME_NAME: Record<BiomeId, string> = {
  valley: 'Green Valley',
  prairie: 'Golden Prairie',
  desert: 'Dust Desert',
  swamp: 'Toxic Swamp',
  tundra: 'Frozen North',
  autumn: 'Ember Hills',
  canyon: 'Red Canyon',
  deadwood: 'Deadwood',
};
